/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterStoneCut_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuStoneCutSelect_itemSearch">;
    readonly " $refType": "SbRespRefineMenuFilterStoneCut_itemSearch";
};
export type SbRespRefineMenuFilterStoneCut_itemSearch$data = SbRespRefineMenuFilterStoneCut_itemSearch;
export type SbRespRefineMenuFilterStoneCut_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenuFilterStoneCut_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterStoneCut_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterStoneCut_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuStoneCutSelect_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'f3308bf86fbdcc031312348564a8b609';
export default node;
